/* eslint-disable react/jsx-filename-extension */
import { h, JSX } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { useScrollDirection } from '@utils/useScrollDirection'

import Logo from '@components/logo/Logo'
import VatPicker from '@features/vatPicker/VatPicker'
import HeaderLinks from './UIHeaderLinks'
import Motivators from './UIMotivators'

export default function Navbar({
    navbarClassName,
    headerLinks,
    menu,
    vat,
    logo,
    isDesktop,
    MenuComponent,
    motivators,
    search,
    SearchComponent,
    cartQuantity,
    wishlistQuantity,
    stickyHeaderScrollThreshold = 100,
    customerLinks = {},
}) {
    const [stuck, setStuck] = useState(false)
    const scrollDirection = useScrollDirection(stickyHeaderScrollThreshold)

    useEffect(() => {
        setStuck(scrollDirection !== 'up')
    }, [scrollDirection])

    return (
        <header className={`${navbarClassName || 'wui-nav'} ${stuck ? '--stuck' : ''}`}>
            {isDesktop && (motivators || vat) && (
                <div className="topbar">
                    <div className="inner">
                        {vat && <VatPicker vats={vat} />}

                        {(motivators && motivators?.length > 0) && (
                            <Motivators motivators={motivators} />
                        )}
                    </div>
                </div>
            )}

            {(logo ||
                headerLinks ||
                menu ||
                MenuComponent ||
                search ||
                SearchComponent) && (
                    <section className="nav-main">
                        {logo && <Logo logo={logo} />}

                        <div
                            id="modal-quicksearch"
                            className="modal hidden fade-out-top"
                            data-drawer-name="search"
                            data-animate-in="fade-in-top"
                            data-animate-out="fade-out-top"
                            data-title="Sök"
                        />

                        <div
                            id="modal-menu"
                            className="modal hidden fade-out-below-navbar"
                            data-drawer-name="menu"
                            data-animate-in="fade-in-below-navbar"
                            data-animate-out="fade-out-below-navbar"
                            data-title="Meny"
                        >
                            {!isDesktop && MenuComponent && (MenuComponent)}
                        </div>

                        {MenuComponent && isDesktop && (MenuComponent)}

                        <HeaderLinks
                            headerLinks={headerLinks}
                            wishlistQuantity={wishlistQuantity}
                            cartQuantity={cartQuantity}
                            showSearchIcon={true}
                            search={search}
                            SearchComponent={SearchComponent}
                            customerLinks={customerLinks}
                        />
                    </section>
                )}
        </header>
    )
}
